module.exports = __webpack_public_path__ + "img/BNI-LargeCorner.4ac3027a.png";